import { type MultiStateDropdownOption } from "components/dropdowns/multiStateDropdown/MultiStateDropdown";
import { ContentTypesEnum } from "enums";

export const communicationsOptions: MultiStateDropdownOption<ContentTypesEnum>[] = [
  {
    label: ContentTypesEnum.Emails,
    iconName: "fa-envelope",
  },
  {
    label: ContentTypesEnum.Messages,
    iconName: "fa-messages",
  },
];
